module.exports = __webpack_public_path__ + "content/algorithm.06169ac1.worker.js"